query Promocode($id: ID!) {
  promocode(id: $id) {
    id
    title
    code
    productIds
    limit
    amount
    discount
    activations
    trialPeriod
    type
    startAt
    finishAt
    totalRevenue {
      value
      currency
    }
    promocodeCampaign {
      id
      title
    }
    createdAt
    updatedAt
  }
}
